import { Box, Link, Typography } from '@mui/material';

import { Panel } from '@/components/common/Panel/Panel';

import { useDocumentPassword } from '@/hooks/useDocumentPassword';

import { linksPanelSx, linksSx, panelSx } from './Help.styles';

export const Help: React.FC = () => {
  const protectedPagesPassword = useDocumentPassword('PROTECTED_PAGES');

  return (
    <Panel sx={panelSx}>
      <Panel ignited sx={linksPanelSx}>
        {protectedPagesPassword && (
          <Box>
            <Typography variant="body2" component="span">
              Password for protected pages:
            </Typography>{' '}
            <Typography variant="body2" component="span" color="primary">
              {protectedPagesPassword}
            </Typography>
          </Box>
        )}

        <Link
          target="_blank"
          rel="noreferrer"
          href="https://resurety.com/cleantrade/cleantrade-quick-start-faqs/"
          sx={linksSx}
        >
          FAQs
        </Link>

        <Link
          target="_blank"
          rel="noreferrer"
          href="https://resurety.com/cleantrade/cleantrade-regulatory-resources/"
          sx={linksSx}
        >
          Regulatory Resources
        </Link>
      </Panel>

      <Link
        target="_blank"
        rel="noreferrer"
        href="mailto:markets.support@resurety.com "
        sx={linksSx}
      >
        Email Support
      </Link>
    </Panel>
  );
};

export default Help;
